import { useQuery } from '@tanstack/react-query';
import { getTasks } from 'api/task.service';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';
import { useParams } from 'react-router-dom';
import { setDraftTask, setTasks, useTaskStore } from 'store/task.store';

export const useTaskGetAllQuery = () => {
  const draftTask = useTaskStore((state) => state.draft);
  const tasks = useTaskStore((state) => state.tasks);
  const params = useParams<{ ['*']: string; taskId: string }>();
  const toast = useToast();

  const { isLoading, isFetching } = useQuery(['tasks'], getTasks, {
    onSuccess: (result) => {
      setTasks(result);

      if (params?.taskId) {
        const task = result.find((item) => item.id === params.taskId);

        setDraftTask(task);
      } else if (params?.['*'] !== 'tasks/create') {
        setDraftTask(result[0]);
      }
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
    staleTime: 0,
    refetchInterval: 1000 * 60 * 5,
    refetchIntervalInBackground: draftTask?.status !== 'NOT_SAVED',
    refetchOnReconnect: draftTask?.status !== 'NOT_SAVED',
    refetchOnWindowFocus: draftTask?.status !== 'NOT_SAVED',
  });

  return { isLoading: isFetching || isLoading, data: tasks };
};
